import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';

const SocialButton = ({ icon: Icon, href, delay }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.5 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.5, delay }}
    viewport={{ once: true }}
  >
    <IconButton
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'rgba(255, 255, 255, 0.7)',
        transition: 'all 0.3s ease',
        '&:hover': {
          color: 'primary.main',
          transform: 'translateY(-5px)',
        },
      }}
    >
      <Icon sx={{ fontSize: 28 }} />
    </IconButton>
  </motion.div>
);

const SocialLinks = ({ data }) => {
  const socialLinks = [
    { icon: FacebookIcon, href: data?.facebook || '/' },
    { icon: InstagramIcon, href: data?.instagram || '/' },
    { icon: TwitterIcon, href: data?.twitter || '/' },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        mt: { xs: 4, md: 6 },
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <Typography
          variant="h6"
          sx={{
            color: 'rgba(255, 255, 255, 0.9)',
            fontWeight: 500,
            textAlign: 'center',
          }}
        >
          Follow Us
        </Typography>
      </motion.div>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          justifyContent: 'center',
        }}
      >
        {socialLinks.map((link, index) => (
          <SocialButton
            key={index}
            icon={link.icon}
            href={link.href}
            delay={index * 0.1}
          />
        ))}
      </Box>
    </Box>
  );
};

export default SocialLinks;
